// extracted by mini-css-extract-plugin
export var dough = "Logo-module--dough--07ec5";
export var link = "Logo-module--link--75143";
export var svg = "Logo-module--svg--e6210";
export var vertical = "Logo-module--vertical--0ed42";
export var wordmark = "Logo-module--wordmark--65cc8";
export var wrapper = "Logo-module--wrapper--e94d3";